import noop from 'lodash/noop';

const noopTrackingProviderValue = {
  trackUnitClickThrough: noop,
  trackUnitPlayed: noop,
  trackWidgetEngaged: noop,
  trackWidgetLoaded: noop,
  trackWidgetInViewport: noop,
  trackMediaBufferCompleted: noop,
  trackMediaBufferStarted: noop,
  trackMediaCompleted: noop,
  trackMediaPaused: noop,
  trackMediaPlaybackHeartbeat: noop,
  trackMediaPlaybackStarted: noop,
  trackMediaSeekCompleted: noop,
  trackMediaSeekStarted: noop,
  viewportTracked: true,
};

export default noopTrackingProviderValue;
